"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppFeatureButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const PreferencesServiceProvider_1 = require("../../providers/PreferencesServiceProvider");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useIsPreferenceActive_1 = require("../../hooks/useIsPreferenceActive");
function AppFeatureButton({ type }) {
    const icon = getIconForType(type);
    const i18NKey = getI18nKeyForType(type);
    const isActive = (0, useIsPreferenceActive_1.useIsPreferenceActive)(type);
    const preferences = (0, PreferencesServiceProvider_1.usePreferencesService)();
    const onClick = () => {
        preferences.toggle(type);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "$isActive": isActive, onClick: onClick, "aria-pressed": isActive, "data-e2e": 'AppFeatureButton_Container', children: [isActive && (0, jsx_runtime_1.jsx)(Check, { name: ui_1.Icons.Checkmark, "data-e2e": 'AppFeatureButton_Check' }), (0, jsx_runtime_1.jsx)(FeatureIcon, { name: icon, selected: isActive, "data-e2e": 'AppFeatureButton_FeatureIcon' }), (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features[i18NKey])] }));
}
exports.AppFeatureButton = AppFeatureButton;
function getIconForType(type) {
    return {
        [bridge_schema_1.PreferenceBoolOption.ShowTabs]: ui_1.Icons.Feature_Tabs,
        [bridge_schema_1.PreferenceBoolOption.ShowTools]: ui_1.Icons.Feature_Tools,
        [bridge_schema_1.PreferenceBoolOption.ShowSaveScreenButton]: ui_1.Icons.Save_Screen,
        [bridge_schema_1.PreferenceBoolOption.ShowExportButton]: ui_1.Icons.Feature_Export,
        [bridge_schema_1.PreferenceBoolOption.ShowARPanel]: ui_1.Icons.Feature_Ar,
        [bridge_schema_1.PreferenceBoolOption.ShowTipsPanel]: ui_1.Icons.Tips,
    }[type];
}
function getI18nKeyForType(type) {
    return {
        [bridge_schema_1.PreferenceBoolOption.ShowTabs]: 'tabs',
        [bridge_schema_1.PreferenceBoolOption.ShowTools]: 'tools',
        [bridge_schema_1.PreferenceBoolOption.ShowSaveScreenButton]: 'saveScreen',
        [bridge_schema_1.PreferenceBoolOption.ShowExportButton]: 'exportImage',
        [bridge_schema_1.PreferenceBoolOption.ShowARPanel]: 'liveModeFeature',
        [bridge_schema_1.PreferenceBoolOption.ShowTipsPanel]: 'tips',
    }[type];
}
const Container = (0, ui_1.withA11y)(styled_components_1.default.button `
  position: relative;

  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 140px;
  margin: 0 2px;

  color: ${({ theme }) => theme.designSystem.textSecondary};
  font-size: 14px;
  line-height: 20px;

  background: ${({ theme }) => theme.designSystem.contentBackground};
  border: 1px solid ${({ theme }) => theme.designSystem.background};

  ${({ $isActive, theme }) => $isActive &&
    (0, styled_components_1.css) `
      background: ${theme.designSystem.highlightedBackground};
      color: ${theme.designSystem.text};

      border: 1px solid ${theme.designSystem.highlightedBorder};
    `};

  border-radius: 4px;

  cursor: pointer;

  user-select: none;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`);
const FeatureIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 100%;
  height: 56px;
  margin-bottom: 22px;

  color: ${({ selected, theme }) => selected ? theme.designSystem.text : theme.designSystem.textSecondary};
`;
const Check = (0, styled_components_1.default)(ui_1.Icon) `
  position: absolute;
  top: 14px;
  left: 14px;

  width: 16px;
  height: 16px;

  color: ${({ theme }) => theme.designSystem.text};
`;
